const SvgItAutomation1 = (props) => (
  <>
    <defs />
    <path
      d="M178 29c47.28 0 91.73 18.41 125.16 51.84C336.59 114.27 355 158.72 355 206s-18.41 91.73-51.84 125.16C269.73 364.59 225.28 383 178 383s-91.73-18.41-125.16-51.84C19.41 297.73 1 253.28 1 206s18.41-91.73 51.84-125.16C86.27 47.41 130.72 29 178 29m0-3C78.59 26-2 106.59-2 206s80.59 180 180 180 180-80.59 180-180S277.41 26 178 26Z"
      strokeWidth={0}
      fill="#042068"
    />
    <path
      d="M245 336.15c-51.44 51.57-134.84 51.57-186.28 0s-52.44-134.64-1-186.2c51.44-51.57 135.95-52.45 187.39-.89 51.44 51.57 51.33 135.53-.11 187.09Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <path
      d="M181.49 336.25c-33.9 33.99-88.87 33.99-122.78 0-33.9-33.99-34.56-88.74-.66-122.73 33.9-33.99 89.6-34.57 123.51-.59 33.9 33.99 33.83 89.33-.07 123.31Z"
      stroke="#042068"
      strokeWidth="3px"
      fill="none"
      strokeMiterlimit={10}
    />
    <circle cx={304} cy={80} r={8} strokeWidth={0} fill="#0062ff" />
    <circle cx={304} cy={80} r={24} stroke="#001d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={240} cy={144} r={8} strokeWidth={0} fill="#0062ff" />
    <circle cx={240} cy={144} r={24} stroke="#001d6c" fill="none" strokeMiterlimit={10} />
    <circle cx={176} cy={208} r={8} strokeWidth={0} fill="#0062ff" />
    <circle cx={176} cy={208} r={24} stroke="#001d6c" fill="none" strokeMiterlimit={10} />
  </>
);

export default SvgItAutomation1;
